/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import Pagination from '../../../components/Pagination';
import 'tw-elements';
import moment from "moment";
import { useLocation, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPrompt from '../../../components/ConfirmationPrompt';
import AnimatedModel from '../../../components/Animation/AnimatedModel';
import { dataService } from '../../../services/data.services';
import GlobalContext from '../../../components/Context/GloablContext';
import Table from './components/Table';
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow';
import EmptyAddScreen from '../../../components/EmptyAddScreen';
import { FeeStructure } from './FeeStructureSlice';
import CardHeader from '../../../components/CardHeader';
import Debounce from '../../../CommonMethods/Debounce';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import TopBar from '../../../components/TopBar';

const MangeFeeStructure = () => {
    const {setToastErrorMessage, setToastmessage, } = useContext(GlobalContext);
    const [ayAPILoading, setAyAPILoading] = useState(true)
    const dispatch = useDispatch();
    const FeeHeadList = useSelector(state => state.FeeStructureSlice);
    const { List} = FeeHeadList;
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [searchParams, setSearchParams] = useSearchParams();
    const [email, setemail] = useState('')
    const [fistLoading, setFirstLoading] = useState(false)
    const [FilterData, setFilterData] = useState({});
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [filterCount, setFilterCount] = useState(0)
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [academicYears, setAcademicYears] = useState('')
    const [academic_year_id, setAcademicYearID] = useState('')
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        setLoading(true);
        setSearchParams({ page_number:  1 })
    }
    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getBranch = useCallback(async () => {
        const branch_id = await GetBranchId();
        // Create a copy of searchParams
        const paramsCopy = new URLSearchParams(searchParams.toString());
        // Constructing API call with academic_year_id
        const academicYearName = paramsCopy.get('academic_year');
        let academicYearIds = [];
        if (academicYearName) {
            const academicYearNames = academicYearName.split('),').map((year, index, arr) => {
                // Add the closing parenthesis back to each element except the last one
                return index < arr.length - 1 ? `${year})` : year;
            });
            academicYearIds = academicYearNames.map(name => {
                const academicYear = academicYears?.find(year => year?.name+` (${year?.status?.charAt(0)?.toUpperCase() + year?.status?.slice(1)})` === name);
                return academicYear ? academicYear._id : null;
            });
            // Filter out null values
            academicYearIds = academicYearIds.filter(id => id !== null);
            setAcademicYearID(academicYearIds); // Setting academicYearID
            // Remove academic_year from paramsCopy
            paramsCopy.delete('academic_year');
        }
        // Convert academicYearIds to a comma-separated string
        const academicYearIdsString = academicYearIds.join(',');
    
        const apiCall = `fee-structures?branch_id=${branch_id.toString()}${academicYearIdsString ? `&academic_year_id=${academicYearIdsString}` : ''}&${(paramsCopy.toString() === '' ? `page_number=1` : paramsCopy.toString())}`;
        try {
            setLoading(true)
            dispatch(FeeStructure(apiCall)).then((response) => {
                if (response?.payload?.data.status===200) {
                    
                    if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setLoading(false);
                            setEmptyScreenMessage("No data found");
                        } else {
                            setLoading(false);
                            setEmptyScreenMessage("No matching records found");
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                    setLoading(false);
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
        } catch (error) {
            setLoading(false);
            setEmptyScreenMessage("No data found");
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }, [searchParams, ayAPILoading]);

    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value, searchType) => {
        // setLoading(true);
        // setEmptyScreenMessage("No matching records found");
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value);}
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        setLoadingActivation(true);
        try {
            let body = { }
            if(confirmationState.status !== "Reset Password") {
                body = {
                    "status": confirmationState.status === 'Activate' ? true : false             
                }
            }
            let endpoint= confirmationState.status==="Reset Password"?`admin-users/reset-password/${confirmationState.item.email_address}`:`admin-users/update/${confirmationState.item.email_address}`
            if(confirmationState.status==="Reset Password"){
                body={
                    reset:true
                }
            }
            const response = await dataService.PatchAPI(body,endpoint);
            setLoadingActivation(false);
            if (response.data.success_status) setToastmessage(response.data.message);
            else setToastErrorMessage(response.data.message);
            handleConformationClick();
            getBranch();
        } catch (error) {
            handleConformationClick();
            setLoadingActivation(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong. Please try again")
        }
    }
    const getFilterData = async(academicYearsForFilter) => {
        const ayNames = academicYearsForFilter.map(year => year?.name+` (${year?.status?.charAt(0)?.toUpperCase() + year?.status?.slice(1)})`);
        const filterObj = {
            academic_year: ayNames,
            status: ['true', 'false'] 
        };
        setFilterData(filterObj)
        let filter_val = {}
        Object.keys(filterObj).map((item) => {
            let params = Object.fromEntries(searchParams);
            
            Object.keys(params).map((subitem) => {
                if(item === subitem) {
                    filter_val[item] = params[item].split(',')
                }
            })
            setFilterCheckBox(filter_val)
            let count = 0
            Object.keys(filter_val).map((item) =>  {
                if(filter_val[item]?.length !== 0) {
                    count += 1
                }
            })
            setFilterCount(count)

        })
    }
    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item]?.length !== 0) {
                count += 1
            }
        })
        if(type) {
            setFilterCount(count)

        } else {
            setFilterCount(0)
        }
    }
    const handleApplyFilter = (type) => {
        setEmptyScreenMessage("No matching records found");
        let params = Object.fromEntries(searchParams);
        
        if(type) {
            let flag = true;
            params["filter"] = true;
            params.page_number = 1;
    
            Object.keys(FilterCheckbox).map((item) => {
                if(FilterCheckbox[item]?.length !== 0) {
                    let val = "";
                    
                    FilterCheckbox[item].map((key) => {
                        // Extract only the academic year name using regex
                        const extractedAY = key;
                        val += `${extractedAY},`;
                    });
                    
                    params[item] = val.slice(0, -1); // Remove the trailing comma
                    setSearchParams({ ...params });
                    flag = false;
                } else {
                    delete params[item];
                    setSearchParams({ ...params });
                }
            });
    
            if (flag) {
                delete params.filter;
                setSearchParams({ ...params });
            }
    
        } else {
            delete params.filter;
            Object.keys(FilterCheckbox).map((item) => {
                delete params[item];
            });
            setSearchParams({ ...params });
            setFilterCheckBox([]);
        }
        
        getCount(type);
    }
    
    /**
     * The function `getAcademicYears` retrieves ongoing and upcoming academic years from an API based on
     * the branch ID and sets the retrieved data to the state variable `AcademicYears`.
     */
    const getAcademicYears = async () => {
        try{
            setAyAPILoading(true)
            const branch_id = await GetBranchId();
            let endpoint = `academic-years?branch_id=${branch_id}&filter=true&status=ongoing,upcoming,completed`;
            const response = await dataService.GetAPI(endpoint);
            const temp = response?.data?.data?.data;
            setAcademicYears(temp);
            getFilterData(temp);
            return temp; // Returning academic years data 
        } catch(error){
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        } finally{
            setAyAPILoading(false)
        }
    };

    useEffect(()=>{
        getAcademicYears()
    },[])

    const fetchData = () =>{
        if(searchParams.get('academic_year') !== null){
            if(!ayAPILoading ){
                getBranch()
            } else{
                return
            }
        } else{
            getBranch();
        }
    }

    useEffect(() => {
        setsearchFieldDebounce(searchParams.get('search') !== null ? decodeURIComponent(searchParams.get('search')) : '')
        // Fetching academic year ID based on academic year name from the given object
        if(!ayAPILoading){
            fetchData()
        }
    }, [searchParams, ayAPILoading]);

    return (
        <>
            <CardHeader noPadding>
                <TopBarWithShadow 
                    AddButton={true}
                    SearchInput={true}
                    Tittle={'Fee Structures'}
                    isFeeStruct={true}
                    AddButtonName={'Add Fee Structure'}
                    SearchValue={searchFieldDebounce}
                    handleOnClickSearch={setsearchFieldDebounce}
                    optimizedFn={optimizedFn}
                    isClick={"/fee-management/fee-structure/add-fee-structure"}
                    ApplyFilter={true}
                    FilterData={FilterData}
                    handleApplyFilter={handleApplyFilter}
                    FilterCheckbox={FilterCheckbox}
                    setFilterCheckBox={setFilterCheckBox}
                    filterCount={filterCount}
                    searchParams={searchParams}
                    customSearchPlaceHolder={`Class Name`}
                    selectedFilterTerm="academic_year"
                    tooltip={true}
                    filterFromPage={'Fee_Structures'}
                />
                <CardHeader body>
                    {loading ? (
                        <ItemShimmer />
                    ) : (
                        <>
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickSort={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setConfirmationState={setConfirmationState}
                                email={email}
                                List={List}
                                setLoading={setLoading}
                                getBranch={getBranch}
                                showHeaders={true}
                                searchParams={searchParams}
                                setSearchParams={setSearchParams}
                            />
                            {(
                                List.total_count > 10 && (
                                    <Pagination
                                        TotalCount={List.total_count}
                                        totalPageNumber={Math.ceil(List.total_count / 10)}
                                        selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                        handleOnClickPageNumber={handleOnClickPageNumber}
                                    />
                                )
                            )}
                        </>
                    )}
                </CardHeader>

            </CardHeader>
            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${confirmationState.status==='Reset Password'?'Reset Password':`${confirmationState.status} User`} `}
                        message = {`Are you sure you want to ${confirmationState.status === 'Reset Password' ? `${confirmationState.status} for` : confirmationState.status} this user ?`}
                        buttonName = {confirmationState.status}
                        loadingActivation={loadingActivation}
                    />
                }
            />  
            }
        </>
    );
}

export default MangeFeeStructure;
